module.exports = __webpack_public_path__ + "img/fondo.8d26d603.jpg";